import React from 'react';
import Spinner from '../../Spinner';
import { FilterWithoutData } from '../../XcalaComponents/FilterWithoutData';
import { CardsFound } from './CardsFound';
import { Grid } from '@mui/material';

export const CardFoundViewWrapper = ({
  fundsFilteredToShow,
  loadingGetSecurityList,
  errorGetSecurityList,
}) => {
  if (loadingGetSecurityList) {
    return <Spinner />;
  }

  if (errorGetSecurityList) {
    throw new Error('Error cardFound');
  }

  if (!fundsFilteredToShow || fundsFilteredToShow.length < 1) {
    return (
      <Grid item xs={12}>
        <FilterWithoutData />
      </Grid>
    );
  }

  return (
    <>
      {fundsFilteredToShow.map(security => {
        const { Name, ID, Custom } = security;
        const custom = JSON.parse(Custom);

        return (
          <Grid item xs={12} sm={6} md={4} key={security.ID}>
            <CardsFound
              key={ID}
              security={security}
              fundName={Name.slice(4)}
              rentabilityFound={custom.fund_details.expected_return}
              typeCurrency={custom.fund_details.currency}
            />
          </Grid>
        );
      })}
    </>
  );
};
